import React, { Component } from "react";
import BackButton from "../core/BackButton";
import { studentAppointmentData } from "../../data/loaders";
import { ProcessesStudentAppointments } from "../../data/process";
import styled from "styled-components";
import Section from "../core/Section";

const PageWrapper = styled.div`
  padding: 10px;
`;
const SelectList = styled.div`
  width: 100%;
  margin-top: 2rem;
  @media only screen and (min-width: 768px) {
    width: 50%;
  }
`;

const scheduledHeaders = [
  "Instructor Name",
  "Lesson Date",
  "Lesson Day",
  "Lesson Time",
  "Scheduled Date",
  "Lesson Meet Time",
  "Lesson Type",
  "Location",
  "Must Pay"
];
const takenHeaders = [
  "Instructor Name",
  "Lesson Date",
  "Lesson Day",
  "Lesson Time",
  "Scheduled Date",
  "Lesson Type",
  "Location"
];
const canceledHeaders = [
  "Instructor Name",
  "Lesson Date",
  "Lesson Day",
  "Lesson Time",
  "Scheduled Date",
  "Date Canceled",
  "Status",
  "Lesson Type",
  "Location"
];

class LessonDashboard extends Component {
  state = {
    data: null,
    loading: true,
    openSection: "scheduled"
  };

  async componentDidMount() {
    this.props.updateMenu("lessons", "Lessons ");
    const studentAppData = await studentAppointmentData();
    const processedStudentAppointments = ProcessesStudentAppointments(
      studentAppData
    );

    this.setState({ data: processedStudentAppointments, loading: false });
  }
  selectSection = e => {
    const newState = { ...this.state };
    newState.openSection = e.target.value;
    this.setState(newState);
  };

  render() {
    if (this.state.loading) return <h4>Loading Lessons</h4>;
    const sections = {
      scheduled: {
        scheduledHeaders,
        title: "Lessons Scheduled"
      },
      taken: {
        takenHeaders,
        title: "Lessons Taken"
      },
      canceled: {
        canceledHeaders,
        title: "Lessons Canceled"
      }
    };
    const { openSection } = this.state;

    return (
      <PageWrapper>
        <BackButton path="/app/student-dashboard" />
        <SelectList>
          <label htmlFor="sectionSelector">
            Please select a lesson status.
          </label>
          <select
            name="sectionSelector"
            onChange={this.selectSection}
            className="custom-select"
          >
            <option value="scheduled">Lessons Scheduled</option>
            <option value="taken">Lessons Taken</option>
            <option value="canceled">Lessons Canceled</option>
          </select>
        </SelectList>
        <Section
          data={this.state.data}
          title={sections[openSection].title}
          name={openSection}
          headers={sections[openSection][`${openSection}Headers`]}
        />
      </PageWrapper>
    );
  }
}

export default LessonDashboard;
export { PageWrapper };
